/* global axios */
import ApiClient from './ApiClient';

// Chat interno entre colaboradores (v78/v79). Permissoes no backend
// (InternalChatController — matriz por papel + time; espiao e bloqueio id1).
class InternalChatAPI extends ApiClient {
  constructor() {
    super('internal_chat', { accountScoped: true });
  }

  contacts(asUserId) {
    return axios.get(`${this.url}/contacts`, {
      params: asUserId ? { as_user_id: asUserId } : {},
    });
  }

  messages(userId, before, asUserId) {
    return axios.get(`${this.url}/messages`, {
      params: {
        user_id: userId,
        ...(before ? { before } : {}),
        ...(asUserId ? { as_user_id: asUserId } : {}),
      },
    });
  }

  send(userId, content, file) {
    if (file) {
      const form = new FormData();
      form.append('user_id', userId);
      form.append('content', content || '');
      form.append('file', file);
      return axios.post(`${this.url}/messages`, form);
    }
    return axios.post(`${this.url}/messages`, { user_id: userId, content });
  }

  markRead(userId) {
    return axios.post(`${this.url}/read`, { user_id: userId });
  }

  blockList() {
    return axios.get(`${this.url}/block_list`);
  }

  setBlock(userId, blocked) {
    return axios.post(`${this.url}/block`, { user_id: userId, blocked });
  }

  // SO id 1: apaga o chat inteiro do par (pros dois lados)
  deleteConversation(userId, asUserId) {
    return axios.post(`${this.url}/delete_conversation`, {
      user_id: userId,
      ...(asUserId ? { as_user_id: asUserId } : {}),
    });
  }

  locateClient(mode, q) {
    return axios.get(`${this.url}/locate_client`, { params: { mode, q } });
  }
}

export default new InternalChatAPI();
